module.exports = __webpack_public_path__ + "img/producer.6964c34b.svg";